import { JSX } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import MovieCard from "@/components/cards/MovieCard";
import Carousel from "@/components/helpers/Carousel.tsx";

import { Content } from "@/@types/general.ts";
import { useGetRecommendationOfDetailPage } from "@/hooks/api/content.hooks";
import { isMobile } from "@/utils/constatns";

import Section from "../helpers/Section/Section";

const DetailSimilarMovies = (): JSX.Element => {
  const { t } = useTranslation();
  const { id } = useParams() as { id: string };
  const { data } = useGetRecommendationOfDetailPage(+id);
  if (!data) return <></>;

  return (
    data?.premier_contents && (
      <>
        <Section title={t("popular-now")} className={"group/section"}>
          <Carousel<Content>
            swiperParams={{
              slidesPerView: 2,
              spaceBetween: 16,
              followFinger: isMobile,
              breakpoints: {
                640: { slidesPerView: 3, slidesPerGroup: 3 },
                1024: { slidesPerView: 4, slidesPerGroup: 4 },
                1280: { slidesPerView: 5, slidesPerGroup: 5, spaceBetween: 12 },
                1440: { slidesPerView: 6, slidesPerGroup: 6, spaceBetween: 16 },
              },
            }}
            items={data?.premier_contents}
            swiperName={"premier_contents-movies-for-detail"}
          >
            {(content) => <MovieCard key={content.id} {...content} />}
          </Carousel>
        </Section>
      </>
    )
  );
};

export default DetailSimilarMovies;
